import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import rootStore from "./core/store";
import "../src/assets/stylesheets/main/main.css";
import "../src/assets/stylesheets/main/public.css";

ReactDOM.render(
  <Provider store={rootStore}>
    {/* TODO 保留basename，兼容之前的请求 */}
    <BrowserRouter basename="/admin">
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root") as HTMLElement
);

serviceWorker.unregister();
